import './components/accordion'
import './components/navigation'

(function () {
    const body = document.body;

    /**
     * Remove preload class
     */
    window.addEventListener('load', function () {
        body.classList.remove('preload');
    });


    /**
     * Fixed header behavior:
     * - Adds "fixed" when scrolling up past viewport height.
     * - Removes "fixed" and adds "slide-out" when scrolling down.
     * - Handles smooth slide-in and slide-out animations.
     */

    document.addEventListener("DOMContentLoaded", () => {
        let lastScrollTop = 0;
        const header = document.getElementById("header");
        let isFixed = false; // Tracks if "fixed" class is active
        // let isScrolled = false; // Tracks if user has scrolled at all
        let ticking = false; // Prevents redundant function calls in the same frame

        /**
         * Handles scroll events and updates header classes based on scroll position.
         */
        const handleScroll = () => {
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const viewportHeight = window.innerHeight; // Get the screen height dynamically
            const removeFixedThreshold = viewportHeight + 300; // Scroll position to remove "fixed"
            const clearSlideOutThreshold = 700; // Scroll position to remove "slide-out"

            // Add "fixed" and "slide-in" when scrolling up past viewport height
            if (scrollTop > viewportHeight && scrollTop < lastScrollTop) {
                if (!isFixed) {
                    header.classList.add("fixed", "slide-in");
                    header.classList.remove("slide-out");
                    isFixed = true;
                }
            }
            // If the header is fixed and the user scrolls down again, add "slide-out"
            else if (isFixed && scrollTop > lastScrollTop) {
                header.classList.remove("fixed", "slide-in");
                header.classList.add("slide-out");
                isFixed = false;
            }
            // Remove "fixed" and apply "slide-out" when scrolling down past removeFixedThreshold
            else if (scrollTop < removeFixedThreshold) {
                if (isFixed) {
                    header.classList.remove("fixed", "slide-in");
                    header.classList.add("slide-out");
                    isFixed = false;
                }
            }

            // Remove "slide-out" when close to the top (ensures smooth appearance)
            if (scrollTop < clearSlideOutThreshold) {
                header.classList.remove("slide-out");
            }

            lastScrollTop = scrollTop;
            ticking = false;
        };

        /**
         * Uses requestAnimationFrame for optimized scroll event handling.
         * This reduces unnecessary function calls and improves performance.
         */
        window.addEventListener("scroll", () => {
            if (!ticking) {
                requestAnimationFrame(handleScroll);
                ticking = true;
            }
        });
    });
})();
